export default __webpack_public_path__ + "static/media/logo-transparent-svg.18d46f25.svg";